<template>
  <div>
    <div
      class="demo-upload-list"
      v-for="(item, index) in uploadList"
      :key="index"
    >
      <template v-if="item.status === 'finished'">
        <img :src="item.url" />
        <div class="demo-upload-list-cover">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item.url)"
          ></Icon>
          <Icon
            type="ios-trash-outline"
            @click.native="handleRemove(item)"
          ></Icon>
        </div>
      </template>
      <template v-else>
        <Progress
          v-if="item.showProgress"
          :percent="item.percentage"
          hide-info
        ></Progress>
      </template>
    </div>
    <Upload
      ref="upload"
      :show-upload-list="false"
      :default-file-list="defaultList"
      :on-success="handleSuccess"
      :format="['png']"
      :max-size="2048"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      multiple
      type="drag"
      :action="url"
      style="display: inline-block;width:120px;"
    >
      <Button icon="ios-cloud-upload-outline" style="height:58px"
        >上传图片</Button
      >
    </Upload>
    <Modal title="View Image" v-model="visible">
      <img :src="imgName" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultList: [],
      uploadList: [],
      imgName: '',
      visible: false,
      imgWidth: 0,
      imgHeight: 0,
      type: '',
    }
  },
  props: {
    url: {
      type: String,
    },
    file: {
      type: String,
    },
  },
  methods: {
    handleRemove(file) {
      this.uploadList.splice(this.uploadList.indexOf(file), 1)
      this.$emit('fileResult', '')
    },
    handleSuccess(res, file) {
      file.url = res.data
      file.name = '7eb99afb9d5f317c912f08b5212fd69a'
      this.uploadList = []
      this.uploadList.push({
        url: res.data,
        status: 'finished',
      })
      this.$emit('fileResult', res.data)
    },
    handleError(res) {
      this.$Message.error(res.msg)
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: file.name + '的文件格式不正确.',
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '超过文件大小限制',
        desc: '文件 ' + file.name + ' 太大, 不能超过2M.',
      })
    },
    handleView(url) {
      this.imgName = url
      this.visible = true
    },
    handleBeforeUpload(file) {
      this.checkImageWH(file)
      if (this.file != '') {
        const check = this.uploadList.length < 1
        if (!check) {
          this.$Notice.warning({
            title: '最多可以上传1张图片.',
          })
        }
        return check
      }
    },
    // checkImageWH  返回一个promise  检测通过返回resolve  失败返回reject组织图片上传
    checkImageWH(file) {
      this.type = file.name.split('.')[1]
      const self = this
      return new Promise((resolve, reject) => {
        const filereader = new FileReader()
        filereader.onload = (e) => {
          const src = e.target.result
          const image = new Image()
          image.onload = () => {
            self.imgWidth = image.width
            self.imgHeight = image.height
          }
          image.onerror = reject
          image.src = src
        }
        filereader.readAsDataURL(file)
      })
    },
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList
  },
  watch: {
    file() {
      this.uploadList = []
      if (this.file != '') {
        this.uploadList.push({
          url: this.file,
          status: 'finished',
        })
      }
    },
  },
}
</script>
<style>
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
